import React from 'react'
import PropTypes from 'prop-types'
import {FormGroup, FieldStatus, Select, MenuItem} from 'rambler-ui'
import genders from './genders'
import styles from './styles.css'

export default function GenderField({
  inline,
  label,
  size,
  meta,
  input,
  autoFocus,
  clearable,
  cerberId
}) {
  const error = meta.touched && meta.error

  return (
    <FormGroup inline={inline} label={label} fieldId={input.name}>
      <FieldStatus type="error" message={error}>
        <div className={inline && size !== 'small' ? styles.medium : ''}>
          <Select
            {...input}
            className="-metrika-nokeys"
            placeholder="Выбрать пол"
            id={input.name}
            size={size}
            autoFocus={autoFocus}
            tabIndex="0"
            status={error ? 'error' : null}
            inputValueRenderer={(value) =>
              value && value !== 'u' ? genders[value] : ''
            }
            onBlur={() => input.onBlur(input.value)}
            data-cerber-id={cerberId}>
            {Object.keys(genders)
              .filter((value) => clearable || value !== 'u')
              .map((value) => (
                <MenuItem key={value} value={value}>
                  {genders[value] || 'Не указан'}
                </MenuItem>
              ))}
          </Select>
        </div>
      </FieldStatus>
    </FormGroup>
  )
}

GenderField.propTypes = {
  inline: PropTypes.bool,
  label: PropTypes.string,
  size: PropTypes.string,
  autoFocus: PropTypes.bool,
  clearable: PropTypes.bool,
  meta: PropTypes.shape(),
  input: PropTypes.shape(),
  cerberId: PropTypes.string
}
